<template src="./payment.html"></template>

<script>
import axios from 'axios'
  import auth from '../../../helpers/auth'
  import StripeCardFields from '../../common/StripeCardFields.vue'
  import {
    captureReferralFromQuery,
    getStoredReferralCode,
    setStoredReferralCode,
    clearStoredReferralCode
  } from '../../../helpers/referral'

  export default {
    name: 'payment',
    components: {
      'app-stripe-card-fields': StripeCardFields
    },
    data: function () {
      return {
        interval: 'yearly',
        submitting: false,
        referralCode: '',
        hasActiveSubscription: false
      }
    },
    methods: {
      onReferralCodeInput: function (value) {
        this.referralCode = setStoredReferralCode(value)
      },
      loadSubscriptionStatus: function () {
        return axios.get('/subscription/status').then((response) => {
          this.hasActiveSubscription = !!(response.data && response.data.subscription_active)
          if (response.data) {
            this.$store.commit('setSubscriptionStatus', response.data)
          }
        }).catch(() => {
          this.hasActiveSubscription = false
        })
      },
      confirmReplaceIfNeeded: function () {
        if (!this.hasActiveSubscription) return Promise.resolve(true)
        return this.swal({
          title: 'Replace current subscription?',
          text: 'You already have an active plan. Continuing will cancel it and replace it with this ' +
            (this.interval === 'yearly' ? 'yearly' : 'monthly') +
            ' plan. You will be charged for the new plan according to its billing cycle.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Replace and subscribe',
          cancelButtonText: 'Cancel'
        }).then((result) => !!(result && result.value))
      },
      tokenize: function () {
        if (this.submitting) return
        const fields = this.$refs.stripeFields
        if (!fields || !fields.isReady()) {
          this.errorNotification('Payment form is not ready. Please wait a moment.')
          return
        }
        this.confirmReplaceIfNeeded().then((ok) => {
          if (!ok) return
          this.submitting = true
          const code = (this.referralCode || getStoredReferralCode() || '').trim()
          return fields.createToken().then((token) => {
            const payload = { token: token.id, interval: this.interval }
            if (code) payload.referral_code = code
            return axios.post('/subscription', payload)
          }).then(() => {
            clearStoredReferralCode()
            return axios.get('/subscription/status')
          }).then((statusRes) => {
            this.$store.commit('setSubscriptionStatus', statusRes.data)
            this.$store.commit('user/setUserSubscription', {
              active: statusRes.data.subscription_active === true
            })
            this.hasActiveSubscription = !!(statusRes.data && statusRes.data.subscription_active)
            return this.swal({
              type: 'success',
              title: 'You have successfully subscribed.',
              text: 'A confirmation email has been sent to ' + this.$store.getters['user/getProfile'].email
            })
          }).then(() => {
            this.$router.push('/')
          }).catch((err) => {
            const msg = err && err.message ? err.message : 'Payment failed. Please try again.'
            this.errorNotification(msg)
          }).finally(() => {
            this.submitting = false
          })
        })
      }
    },
    created: function () {
      const q = this.$route.query.interval || 'yearly'
      this.interval = (q === 'monthly' || q === 'yearly') ? q : 'yearly'
      captureReferralFromQuery(this.$route.query)
      this.referralCode = getStoredReferralCode()
      auth.check(this, false)
      this.loadSubscriptionStatus()
    }
  }
</script>

<style scoped>
.payment-form-column {
  position: relative;
  z-index: 2;
}

.payment-summary-column {
  position: relative;
  z-index: 1;
}
</style>
